<template>
    <v-container fluid class="grey lighten-4">
        <v-row>
            <!-- Sidebar -->
            <v-col cols="12" md="3">
                <v-card class="pa-4">
                    <v-card-title>Options</v-card-title>
                    <v-divider></v-divider>
                    <v-select v-model="selectedOption" label="Page Type" dense outlined :items="options"></v-select>

                    <!-- Dropdown with a Placeholder -->
                    <v-select
                        v-model="userTierSelectedOption"
                        :items="tierOptions"
                        label="User Tier"
                        placeholder="Select User Tier"
                        item-text="label"
                        item-value="value"
                        dense
                        outlined/>

                    <v-text-field label="Input 1" dense outlined></v-text-field>
                    <v-text-field label="Input 2" dense outlined></v-text-field>
                </v-card>
            </v-col>
            <v-col cols="12" md="9">
                <v-text-field
                    v-model="xmlIdsInput"
                    :rules="[v => !!v || 'XML ID(s) is required']"
                    label="XML ID(s)"
                    outlined
                    dense
                    hide-details="auto"
                    class="mb-2"
                ></v-text-field>

                <v-btn
                    :block="isMobilePort"
                    color="primary"
                    @click="loadSection"
                    :loading="isLoading"
                    class="mb-2"
                >
                    Load Section
                </v-btn>
                    <div v-if="hasError" class="error--text">
                        <p>There is an error while fetching data from the query. Please try again later.</p>
                    </div>

                    <div v-if="isNoDataFound">
                        <p>No content found for query <b>"{{ xmlIdsInput }}"</b></p>
                    </div>
                <div v-else>
                    <default-content-section-controller
                        :contentSections="contentSections"
                    />
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import DefaultContentSectionController from "../../components/content-section/DefaultContentSectionController.vue";
import Mobile from "../../components/inc/mixins/mobile";
import {ContentSectionApi} from "../../api/ContentSectionApi";

export default {
    components: { DefaultContentSectionController },
    mixins: [Mobile],
    data() {
        return {
            /**
             * @type {Array<ContentSectionType>}
             */
            contentSections: [],
            xmlIdsInput: '', // bound to input field
            xmlIdsQuery: {},
            isLoading: false,
            hasError: false,
            options: ['General'],
            selectedOption: 'General',
            userTierSelectedOption: null, // Bind to v-select for User Tier
            tierOptions: [
                {label: 'Select User Tier', value: null},
                {label: 'Basic', value: 'basic'},
                {label: 'Premium',value: 'premium'}
            ],
            hasFetched: false
        };
    },
    computed: {
        isNoDataFound() {
            return this.hasFetched && !this.contentSections.length && this.xmlIdsInput && !this.isLoading;
        }
    },
    watch: {
        xmlIdsInput() {
            this.hasFetched = false;
        }
    },
    mounted() {
        const url = new URL(window.location.href);
        const raw = url.searchParams.get("xmlIds");

        if (raw) {
            try {
                const parsed = JSON.parse(decodeURIComponent(raw));
                this.xmlIdsInput = parsed.xmlIds || "";
                this.userTierSelectedOption = parsed.userTierEmulation || null;
                this.xmlIdsQuery = parsed;
                if (this.xmlIdsInput) {
                    this.loadSection();
                }
            } catch (e) {
                console.error("Failed to parse xmlIds query:", e);
            }
        }
    },
    methods: {
        async loadSection() {
            if (!this.xmlIdsInput) return;

            this.xmlIdsQuery = {
                xmlIds: this.xmlIdsInput,
                userTierEmulation: this.userTierSelectedOption
            };
            await this.handleQueryChange();
            this.updateUrlAndHistory();
        },
        updateUrlAndHistory() {
            const url = new URL(window.location.href);
            const serialized = encodeURIComponent(JSON.stringify(this.xmlIdsQuery));
            url.searchParams.set("xmlIds", serialized);
            window.history.replaceState({}, "", url.toString());
        },
        async handleQueryChange() {
            this.setLoading(true);
            this.hasError = false;
            this.hasFetched = false;
            this.contentSections = [];
            try {
                this.contentSections = await ContentSectionApi.queryXmlIds(this.xmlIdsQuery);
            } catch (err) {
                this.errorMessage = err.response.data.error;
                this.hasError = true;
            } finally {
                this.setLoading(false);
                this.hasFetched = true;
            }
        },
        setLoading(value) {
            this.isLoading = value;
        }
    }
};
</script>

<style scoped lang="scss">
</style>